import { Box } from "@mui/material";
import { Field } from "react-final-form";
import Button from "../../../components/Button";
import { InputText } from "../../../components/Input";
import { required } from "../../../utils/validations";

const CardMoneda = ({ name, onclick, disabled }) => (
  <Box
    className="col-12 col-lg-10 col-xl-8"
    sx={{ display: "flex", flexWrap: "wrap" }}
  >
    <Box className="col-3" sx={{ p: 1 }}>
      <Field
        validate={required}
        name={`${name}.monedaDescripcion`}
        component={InputText as any}
        label="Descripcion"
      />
    </Box>
    <Box className="col-3" sx={{ p: 1 }}>
      <Field
        validate={required}
        name={`${name}.monedaSigno`}
        component={InputText as any}
        label="Signo"
      />
    </Box>
    <Box className="col-3" sx={{ p: 1 }}>
      <Field
        validate={required}
        name={`${name}.monedaOrden`}
        component={InputText as any}
        label="Orden"
      />
    </Box>
    <Box
      className="col-2"
      sx={{ display: "flex", alignItems: "center", maxHeight: 50 }}
    >
      <Button label={"Aplicar"} onClick={onclick} disabled={disabled} />
    </Box>
  </Box>
);
export default CardMoneda;
